import {
  getAssembleiasAssessorBffEndpoint,
  getAssembleiasAssessorEndpoint,
  getEventoAssociadoEndpoint,
} from 'library/Apis';
import { AnexoPautaType } from 'helpers/enums/anexoPauta';
import {
  ArrayBufferDownloadHeaders,
  getMergedParamsFromObject,
  toRequest,
} from 'helpers/utils/RequestUtils';
import ApiService from './ApiService';

export const deleteAnexoPauta = (
  idEvento: number,
  idPauta: number,
  idAnexo: number
) => {
  const url = `${getAssembleiasAssessorEndpoint()}anexo-pauta/pauta/${idEvento}/${idPauta}/${idAnexo}`;
  return toRequest<void>(ApiService.delete, [url]);
};

export const deleteAnexoPautaRegister = (
  idEvento: number,
  idPauta: number,
  idAnexo: number
) => {
  const url = `${getAssembleiasAssessorEndpoint()}anexo-pauta/pauta/${idEvento}/${idPauta}/${idAnexo}`;
  return toRequest<void>(ApiService.delete, [url]);
};

export const getAnexosPauta = (idEvento: number, idPauta: number) => {
  const url = `${getAssembleiasAssessorEndpoint()}anexo-pauta/pauta/${idEvento}/${idPauta}`;
  return toRequest<AnexoPautaType[]>(
    ApiService.get,
    [url],
    'listaAnexosPauta',
    false
  );
};

export const getAttachmentRegister = (idEvento: number, idPauta: number) => {
  const url = `${getAssembleiasAssessorBffEndpoint()}agenda/attachment/${idEvento}/${idPauta}`;
  return toRequest<AnexoPautaType[]>(
    ApiService.get,
    [url],
    'listaAnexosPauta',
    false
  );
};

// POST /Anexo-pauta (idEvento, idPauta, tipo, descricao, url, file,...) ​
export const postAnexoPauta = (
  idEvento: number,
  idPauta: number,
  anexo: Partial<AnexoPautaType>
) => {
  const { url, tipoAnexo, descricao, flgDisponivelAssociado, file } = anexo;
  let fd: FormData | undefined;
  if (file) {
    fd = new FormData();
    fd.append('file', file);
  }

  const reqUrl = encodeURI(
    `${getAssembleiasAssessorBffEndpoint()}agenda/attachment/${idEvento}/${idPauta}?${getMergedParamsFromObject(
      { url, tipoAnexo, descricao, flgDisponivelAssociado }
    )}`
  );
  return toRequest<AnexoPautaType>(ApiService.post, [
    encodeURI(reqUrl),
    fd,
    fd
      ? {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      : {},
  ]);
};

export const putAnexoPauta = (
  idEvento: number,
  idPauta: number,
  anexo: AnexoPautaType
) => {
  const { oidAnexoPauta, descricao, flgDisponivelAssociado } = anexo;
  const url = `${getAssembleiasAssessorEndpoint()}anexo-pauta/pauta/${idEvento}/${idPauta}/${oidAnexoPauta}?${getMergedParamsFromObject(
    { descricao, flgDisponivelAssociado }
  )}`;
  return toRequest<AnexoPautaType>(ApiService.put, [encodeURI(url)]);
};

export const getDownloadAnexo = (
  idEvento: number,
  idPauta: number,
  idAnexo: number
) => {
  const url = `${getAssembleiasAssessorEndpoint()}anexo-pauta/pauta/${idEvento}/${idPauta}/${idAnexo}`;
  return toRequest<ArrayBuffer>(ApiService.get, [
    url,
    ArrayBufferDownloadHeaders,
  ]);
};

export const getDownloadAnexoRegister = (
  idEvento: number,
  idPauta: number,
  idAnexo: number
) => {
  const url = `${getAssembleiasAssessorBffEndpoint()}agenda/attachment/${idEvento}/${idPauta}/${idAnexo}`;
  return toRequest<ArrayBuffer>(ApiService.get, [
    url,
    ArrayBufferDownloadHeaders,
  ]);
};

export const postAnexoPautaRegister = (
  idEvento: number,
  idPauta: number,
  anexo: Partial<AnexoPautaType>
) => {
  const { url, tipoAnexo, descricao, flgDisponivelAssociado, file } = anexo;
  let fd: FormData | undefined;
  if (file) {
    fd = new FormData();
    fd.append('file', file);
  }
  const reqUrl = encodeURI(
    `${getAssembleiasAssessorBffEndpoint()}agenda/attachment/${idEvento}/${idPauta}?${getMergedParamsFromObject(
      { url, tipoAnexo, descricao, flgDisponivelAssociado }
    )}`
  );
  return toRequest<AnexoPautaType>(ApiService.post, [
    encodeURI(reqUrl),
    fd,
    fd
      ? {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      : {},
  ]);
};

export const putAnexoPautaRegister = (
  idEvento: number,
  idPauta: number,
  anexo: AnexoPautaType
) => {
  const { oidAnexoPauta, descricao, flgDisponivelAssociado } = anexo;
  const url = `${getAssembleiasAssessorBffEndpoint()}agenda/attachment/${idEvento}/${idPauta}/${oidAnexoPauta}?${getMergedParamsFromObject(
    { descricao, flgDisponivelAssociado }
  )}`;
  return toRequest<AnexoPautaType>(ApiService.put, [encodeURI(url)]);
};

// Associado
export const getAnexosPautaAssociado = (idEvento: number, idPauta: number) => {
  const url = `${getEventoAssociadoEndpoint()}pauta/anexos?${getMergedParamsFromObject(
    { idEvento, idPauta }
  )}`;
  return toRequest<AnexoPautaType[]>(
    ApiService.get,
    [url],
    'listaAnexosPauta',
    false
  );
};

export const downloadAnexoPautaAssociado = (
  idEvento: number,
  idPauta: number,
  idAnexoPauta: number
) => {
  const url = `${getEventoAssociadoEndpoint()}pauta/download-anexo?${getMergedParamsFromObject(
    { idEvento, idPauta, idAnexoPauta }
  )}`;
  return toRequest<ArrayBuffer>(ApiService.get, [
    url,
    ArrayBufferDownloadHeaders,
  ]);
};
